import React from "react";

function Patient(props) {
  return <h1>Patient Page</h1>;
}

export default Patient;